import CubexService from "@/services/setting/cubex";

export default {
    namespaced: true,
    state: {
        selectedItems: JSON.parse(
            localStorage.getItem("cubex_selected_items") || "[]"
        ),
        selectedUsers: JSON.parse(
            localStorage.getItem("cubex_selected_users") || "[]"
        ),
        credentials: null
    },
    mutations: {
        SET_SELECTED_ITEMS(state, items) {
            state.selectedItems = items;
            localStorage.setItem("cubex_selected_items", JSON.stringify(items));
        },
        CLEAR_SELECTED_ITEMS(state) {
            state.selectedItems = [];
            localStorage.removeItem("cubex_selected_items");
        },
        SET_SELECTED_USERS(state, users) {
            state.selectedUsers = users;
            localStorage.setItem("cubex_selected_users", JSON.stringify(users));
        },
        CLEAR_SELECTED_USERS(state) {
            state.selectedUsers = [];
            localStorage.removeItem("cubex_selected_users");
        },
        SET_CREDENTIALS(state, credentials) {
            state.credentials = credentials;
        },
        CLEAR_CREDENTIALS(state) {
            state.credentials = null;
        }
    },
    actions: {
        setSelectedItems({ commit }, items) {
            commit("SET_SELECTED_ITEMS", items);
        },
        clearSelectedItems({ commit }) {
            commit("CLEAR_SELECTED_ITEMS");
        },
        setSelectedUsers({ commit }, users) {
            commit("SET_SELECTED_USERS", users);
        },
        clearSelectedUsers({ commit }) {
            commit("CLEAR_SELECTED_USERS");
        },
        setCubexCredentials({ commit }, credentials) {
            commit("SET_CREDENTIALS", credentials);
        },
        clearCubexCredentials({ commit }) {
            commit("CLEAR_CREDENTIALS");
        },
        async loadCubexCredentials({ commit, state, rootGetters, dispatch }) {
            // check cubex feature status
            await dispatch(
                "checkFeatureEnabled",
                { key: "cubex" },
                { root: true }
            );

            const featuresEnabled = rootGetters.featuresEnabled;
            const isCubexEnabled =
                featuresEnabled && featuresEnabled.cubex == true;

            if (!isCubexEnabled) {
                return null;
            }

            // Only load if not already loaded and CUBEX extension is enabled
            if (state.credentials !== null) {
                return state.credentials;
            }

            try {
                const response = await CubexService.getCubexSetting();
                if (response?.resources?.data) {
                    const credentials = response.resources.data;
                    commit("SET_CREDENTIALS", credentials);

                    return credentials;
                }

                return null;
            } catch (error) {
                console.error("Failed to load CUBEX credentials:", error);
                return null;
            }
        },
        async refreshCubexCredentials({ commit }) {
            commit("SET_CREDENTIALS", null);
            return this.dispatch("cubex/loadCubexCredentials");
        }
    },
    getters: {
        selectedItems: state => state.selectedItems,
        selectedUsers: state => state.selectedUsers,
        credentials: state => state.credentials
    }
};
